import React from "react";
import TopNav from "../layouts/TopNav";
import "../Styles/Product.css";
import { FiRefreshCcw } from "react-icons/fi";
import { Outlet, Link, useLocation } from "react-router-dom";

const Report = () => {
  const location = useLocation();
  const onRefresh = () => {
    window.location.reload();
  };
  return (
    <div className="board">
      <TopNav title="Report" />

      <div className="product">
        <div className="productBtn">
          <button onClick={onRefresh} className="productBtn1">
            <FiRefreshCcw />
            Refresh
          </button>
          <Link to="/dashboard/report">
            <button
              className={
                location.pathname === "/dashboard/report"
                  ? "activeButton"
                  : "productBtn1"
              }
            >
              Requisition
            </button>
          </Link>
          <Link to="/dashboard/report/loadingreport">
            <button
              className={
                location.pathname === "/dashboard/report/loadingreport"
                  ? "activeButton"
                  : "productBtn1"
              }
            >
              Loading Slip
            </button>
          </Link>
          <Link to="/dashboard/report/allocationreport">
            <button
              className={
                location.pathname === "/dashboard/report/allocationreport"
                  ? "activeButton"
                  : "productBtn1"
              }
            >
              Allocations
            </button>
          </Link>
          <Link to="/dashboard/report/bankreport">
            <button
              className={
                location.pathname === "/dashboard/report/bankreport"
                  ? "activeButton"
                  : "productBtn1"
              }
            >
              Bank
            </button>
          </Link>
          <Link to="/dashboard/report/invoiceReport">
            <button
              className={
                location.pathname === "/dashboard/report/invoiceReport"
                  ? "activeButton"
                  : "productBtn1"
              }
            >
              Invoice
            </button>
          </Link>
          <Link to="/dashboard/report/approvalreport">
            <button
              className={
                location.pathname === "/dashboard/report/approvalreport"
                  ? "activeButton"
                  : "productBtn1"
              }
            >
              Approval
            </button>

            
          </Link>

          <Link to="/dashboard/report/refundreport">
          <button
              className={
                location.pathname === "/dashboard/report/refundreport"
                  ? "activeButton"
                  : "productBtn1"
              }
            >
              Refunds
            </button>
          </Link>

          <Link to="/dashboard/report/truckinout">
          <button
              className={
                location.pathname === "/dashboard/report/truckinout"
                  ? "activeButton"
                  : "productBtn1"
              }
            >
              TruckInOut
            </button>
          </Link>
        </div>

        <Outlet />
      </div>
    </div>
  );
};

export default Report;